import MapboxDraw from "@mapbox/mapbox-gl-draw";

const original = { ...(MapboxDraw.modes.draw_polygon as any) };
export const RiskDrawPolygon = {
  ...MapboxDraw.modes.draw_polygon,
  toDisplayFeatures(state, geojson, display) {
    this.map.fire("draw.drawingUpdate", {
      features: [state.polygon],
    });

    original.toDisplayFeatures.call(this, state, geojson, display);
  },
};
